import { Fragment, useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { BackLink } from '../../../../components/navigation/BackLink';
import VisualizationContext from '../../../../contexts/VisualizationContext';
import { LayoutGestaoLeads } from './components/LayoutGestaoLeads';
import { TableEquipes } from './components/TableEquipes';
import { Toast } from './components/Toast';
import {
  EquipesContextProvider,
  useEquipesContext
} from './context/EquipesContext';

export const EquipesLeads = () => {
  const { showToast } = useEquipesContext();
  const { visualizationState, setVisualizationState } =
    useContext(VisualizationContext);

  useEffect(() => {
    setVisualizationState('gestao');
  }, []);

  return (
    <LayoutGestaoLeads>
      <div className="tw-h-[80vh]">
        <div className="tw-bg-[#EBEBEB] tw-w-[100%] mb:tw-w-[93%] mb:tw-mx-[0.8rem] tw-flex tw-justify-between tw-flex-col tw-h-[8rem] md:tw-w-[33.75rem] tw-my-[1.88rem] tw-p-[1.3rem] tw-font-bold tw-rounded-[1rem]">
          <p>Cadastro de equipe</p>
          <Link to={'/corretor/leads/equipes/cadastro-equipe'}>
            <button className="tw-w-[13.3125rem] tw-bg-[#001E64] tw-rounded-[2rem] tw-p-[0.5625rem_2.5rem]  tw-text-[white]">
              Criar equipe
            </button>
          </Link>
        </div>
        <div className="tw-bg-[#FFF] tw-pt-[1.25rem] tw-p-[1rem] tw-rounded-[1rem] mb:tw-mx-[0.8rem] tw-shadow-[0px_0px_5px_rgba(50,50,50,0.25)]">
          <TableEquipes />
        </div>
      </div>
      {showToast && (
        <Toast
          typeMessage={'success'}
          message={'As alterações foram salvas com sucesso!!!'}
        />
      )}
    </LayoutGestaoLeads>
  );
};
